import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { addUrlProps, UrlQueryParamTypes, multiPushInUrlQuery } from 'react-url-query';
import { connect, PromiseState } from 'react-refetch';

import PromiseStateContainer from '../../apiAccess/PromiseStateContainer';
import BASE_URL from '../../apiAccess/urls';
import SearchNav from '../searchNav/SearchNav';
import SingleNutrientQueryBuilder from './SingleNutrientQueryBuilder';
import SingleNutrientDetailsTable from './SingleNutrientDetailsTable';
import SingleNutrientResult from './SingleNutrientResult';
import { getValidCodes, getValidGroup } from '../../util/util';
import Buttons from '../../util/Buttons';
import PrintHeader from '../../presentation/Print/PrintHeader';
import PrintDisclaimer from '../../presentation/Print/PrintDisclaimer';

const urlPropsQueryConfig = {
  code: { type: UrlQueryParamTypes.string },
  group: { type: UrlQueryParamTypes.string },
  page: { type: UrlQueryParamTypes.number },
  size: { type: UrlQueryParamTypes.number },
  sort: { type: UrlQueryParamTypes.string },
  order: { type: UrlQueryParamTypes.string },
};

const handleSubmit = function(query) {
  // onChangeXXX does not push history. use multiPushInUrlQuery.
  multiPushInUrlQuery({
    code: query.code,
    group: query.group,
    page: '',
    sort: '',
    order: '',
  });
};

const handlePageChange = function(newPage, newSize) {
  multiPushInUrlQuery({
    page: newPage,
    size: newSize,
  });
};

const handleSortChange = function(newSortName, newSortOrder) {
  multiPushInUrlQuery({
    sort: newSortName,
    order: newSortOrder,
    page: '',
  });
};

/**
 * Concerns of this component:
 *   control url query
 *   fetch /component
 *   fetch /food/group
 *   validate 'code' and 'group' from url query
**/
class SingleNutrientSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      csvData: [],
    };

    this.setCsvData = this.setCsvData.bind(this);
    this.renderOnFulfillment = this.renderOnFulfillment.bind(this);
  }

  setCsvData(newCsvData) {
    this.setState({csvData: newCsvData});
  }

  render() {
    const { componentFetch, groupFetch } = this.props;
    return (
      <PromiseStateContainer
        ps={PromiseState.all([componentFetch, groupFetch])}
        onFulfillment={this.renderOnFulfillment}
      />
    );
  }

  renderOnFulfillment([components, groups]) {
    let validCodes = getValidCodes(this.props.code, components);
    // limit number of codes to 1.
    if (validCodes.length > 1) {
      validCodes = validCodes.splice(0, 1);
    }
    const validGroup = getValidGroup(this.props.group);

    // CSV configuration
    const csvHeader = [
      {label: 'Food', key: 'shortname'},
      {label: 'FCDB Food ID', key: 'recordid'},
      {label: 'Serving Size or CSM', key: 'serving_size_value'},
      {label: 'Serving Size Unit', key: 'serving_size_unit'},
      {label: 'Quantity per 100 g', key: 'value'},
      {label: 'Nutrient Unit', key: 'unit'},
      {label: 'Quantity per serve', key: 'amount'},
      {label: 'Nutrient Unit', key: 'unit'},
      {label: '%DI Per Serve', key: 'percent_RDI'},
    ];
    const componentObject = components.find(component => component.code === validCodes[0]);
    const csvComponentName = componentObject ? componentObject.display_name : '';
    const groupObject = groups.find(group => group.code === validGroup);
    const csvGroupName = groupObject ? groupObject.display_label : 'All Groups';
    const csvFilename = `Nutrient Search Result - ${csvComponentName} in ${csvGroupName}.csv`;

    return (
      <div className="SingleNutrientSearch">
        <Helmet title="Search for a Nutrient - New Zealand Food Composition Database" />

        <PrintHeader title='SEARCH FOR A NUTRIENT' />

        <SearchNav currentPath={this.props.match.url}>
          <SingleNutrientQueryBuilder
            components={components}
            groups={groups}
            selectedComponent={validCodes}
            selectedGroup={validGroup}
            handleSubmit={handleSubmit} />
        </SearchNav>

        {validCodes[0] &&
          <Buttons
            csvHeader={csvHeader}
            csvData={this.state.csvData}
            filename={csvFilename}
          />
        }

        <SingleNutrientDetailsTable
          component={components.find(component => component.code === this.props.code)} />

        <SingleNutrientResult
          handlePageChange={handlePageChange}
          handleSortChange={handleSortChange}
          code={validCodes[0]}
          group={validGroup}
          page={this.props.page}
          size={this.props.size}
          sort={this.props.sort}
          order={this.props.order}
          setCsvData={this.setCsvData}
        />

        <PrintDisclaimer />
      </div>
    );
  }
}

SingleNutrientSearch.propTypes = {
  history: PropTypes.object,
  location: PropTypes.object,
  match: PropTypes.object,
  code: PropTypes.string,
  group: PropTypes.string,
  page: PropTypes.number,
  size: PropTypes.number,
  sort: PropTypes.string,
  order: PropTypes.string,
  componentFetch: PropTypes.instanceOf(PromiseState),
  groupFetch: PropTypes.instanceOf(PromiseState),
};

const fetch = () => ({
  //componentFetch: `${BASE_URL}/component`,
  //componentFetch: `${BASE_URL}/component/set/getall`,
  componentFetch: `${BASE_URL}/component/set/name?set_name=All%20Components%20Ordered`,
  groupFetch: `${BASE_URL}/food/group`,
});

export default addUrlProps({ urlPropsQueryConfig })(connect(fetch)(SingleNutrientSearch));



// WEBPACK FOOTER //
// ./src/components/search/singleNutrient/SingleNutrientSearch.js